import styled from 'styled-components';

const PRIMARY = '#1976d2'; // the theme blue one step darker, so white text passes AA (4.6:1)
const BORDER = '#e0e0e0';

// The panel's scroll area already keeps clear of the footer
export const Summary = styled.section`
    margin: 12px 0 0;
    border: 1px solid ${BORDER};
    border-radius: 8px;
    padding: 10px 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SummaryTitle = styled.h3`
    display: flex;
    align-items: center;
    margin: 0;
    font-size: 15px;
    font-weight: 700;
`;

export const SummaryText = styled.div`
    font-size: 13px;
    color: #424242;
`;

export const OpenRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const HeaderSide = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const OpenButton = styled.button`
    flex: 1;
    height: 38px;
    border: 1px solid ${PRIMARY};
    border-radius: 4px;
    background: white;
    color: ${PRIMARY};
    font-size: 14px;
    font-weight: 700;
    font-family: inherit;
    cursor: pointer;

    &:focus-visible {
        outline: 2px solid ${PRIMARY};
        outline-offset: 1px;
    }
`;

// The dialog follows design B (owner's choice, 2026-11-01): title and hint above, the table, summary and actions below
const DIALOG_TEXT = '#1F2A33';
const DIALOG_MUTED = '#5F6B73';

export const DialogBody = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    text-align: right;
    color: ${DIALOG_TEXT};
`;

export const DialogHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 14px 22px;
`;

export const DialogTitle = styled.h2`
    margin: 0;
    font-size: 19px;
    font-weight: 500;
`;

export const DialogHint = styled.div`
    margin-top: 2px;
    font-size: 12.5px;
    color: ${DIALOG_MUTED};
`;

export const DialogContent = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 0 22px;
`;

export const DialogActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 22px;
`;

export const DialogSummary = styled.div`
    font-size: 13px;
    color: ${DIALOG_MUTED};
`;

export const DialogButtons = styled.div`
    display: flex;
    gap: 10px;
`;

export const SaveButton = styled.button`
    height: 38px;
    padding: 0 26px;
    border: 0;
    border-radius: 6px;
    background: ${PRIMARY};
    color: white;
    font-size: 14px;
    font-weight: 500;
    font-family: inherit;
    cursor: pointer;

    &:focus-visible {
        outline: 2px solid ${PRIMARY};
        outline-offset: 2px;
    }
`;

export const CancelButton = styled.button`
    height: 38px;
    padding: 0 18px;
    border: 1px solid #c4c4c4;
    border-radius: 6px;
    background: white;
    color: #424242;
    font-size: 14px;
    font-family: inherit;
    cursor: pointer;

    &:focus-visible {
        outline: 2px solid ${PRIMARY};
        outline-offset: 2px;
    }
`;
